import React, { useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import { postBugReport, clearToast } from "../../../_actions/user_actions";
import { Button, Tooltip, Modal, Input, Form, Cascader, message } from 'antd';
import { BugOutlined } from '@ant-design/icons';

function ErrorReport(props) {

  const { TextArea } = Input;
  const dispatch = useDispatch();
  const userData = props.data?.user.userData ?? ["Loading"]

  useEffect(() => {
    const toast = props?.data?.user?.toast;
    if (!toast) return; // Don't do anything if toast is undefined or null

    if (toast === "Bug Failed") {
      message.error("Failed to submit bug report. Please try again.");
      dispatch(clearToast())
    } else if (toast === "Bug Success") {
      message.success("Bug report submitted. Thank you!");
      dispatch(clearToast())
    }
  }, [props?.data?.user?.toast, dispatch]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  // Create a form instance to use Form methods programmatically
  const [form] = Form.useForm(); 

  const showModal = () => {
    setIsModalOpen(true);
  };

  // This function will be called when the form is submitted and validated
  const onFinish = (values) => {

    const capturedErrors = window.getCapturedErrors ? window.getCapturedErrors() : [];
    window.clearCapturedErrors && window.clearCapturedErrors();
    
    // Assuming dataToSubmit is declared outside onFinish or passed in
    if (!userData._id) {
      setIsModalOpen(false);
      form.resetFields();
      return;
    }
    let dataToSubmit = {
      url: window.location.href,
      browser: navigator.userAgent,
      os: navigator?.userAgentData?.platform || navigator?.platform,
      screen: window.screen.width + "x" + window.screen.height,
      userID: userData._id, // ✅ fixed casing
      console: capturedErrors, // ✅ fixed format
      email: values.email,
      phone: values.phone,
      description: values.description,
      severity: values.severity ? values.severity[0] : null
    };
    
    // Dispatch your bug report action with the complete data
    dispatch(postBugReport(dataToSubmit));

    setIsModalOpen(false);
    form.resetFields(); // Reset form fields after successful submission
  };

  const handleOk = () => {
    // Manually trigger form submission and validation
    form.submit(); 
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields(); // Optionally reset fields on cancel
  };

  const options = [
    {
      value: 'low',
      label: 'Low',
    },
    {
      value: 'medium',
      label: 'Medium',
    },
    {
      value: 'high',
      label: 'High',
    },
  ];
    
  return (
    <>
      <Tooltip title="Bug Report" placement="right">
        <Button type="primary" shape="circle" icon={<BugOutlined />} onClick={showModal} />
        <Modal 
          title="Bug Report" 
          open={isModalOpen} 
          onOk={handleOk} 
          okText="Send"
          onCancel={handleCancel}
          // Do not set onOk directly on Modal if you want Form's validation
          // Instead, handle the form submission within the Form component itself
        >
          <Form 
            form={form} // Connect the form instance
            labelCol={{span: 8,}}
            wrapperCol={{span: 16,}}
            initialValues={{remember: true,}}
            autoComplete="off"
            onFinish={onFinish} // This is where you get your values!
            onFinishFailed={(errorInfo) => { // Optional: handle validation errors
                console.log('Failed:', errorInfo);
            }}
          >
            {userData?.role > 0 && (
              <>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: false,
                      message: 'Please input your email',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[
                    {
                      required: false,
                      message: 'Please input your phone number',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </>
            )}
            <Form.Item
              label="Description"
              name="description"
              rules={[
              {
                  required: true,
                  message: 'Please describe this bug',
              },
              ]}
            >
              <TextArea rows={4} />
            </Form.Item>
            <Form.Item
              label="Severity"
              name="severity"
              rules={[
              {
                  required: true,
              },
              ]}
            >
              <Cascader options={options} placeholder="Please select" />
            </Form.Item>
            {/* Ant Design Form does not require an explicit submit button inside the Form component itself if you are triggering it from Modal's onOk. The `form.submit()` call handles it. */}
          </Form>
        </Modal>
      </Tooltip>
    </>
    );
}

function mapStateToProps(state) {
  return {
    data: state
  };
}

export default connect(mapStateToProps)(ErrorReport)